import { useState } from 'react'
import type { LucideIcon } from 'lucide-react'
import type { SystemTags } from '@hewey/shared'
import { RecipePlaceholder } from './RecipePlaceholder.tsx'

type Props = {
	// Null (no photo yet) or a failed load both fall back to the placeholder.
	src: string | null
	seed: string
	tags?: SystemTags | null | undefined
	title: string
	icon?: LucideIcon | undefined
	// Applied to the <img>; the placeholder fills the parent itself.
	className?: string | undefined
	loading?: 'lazy' | 'eager'
}

// A recipe image that degrades to a deterministic icon placeholder when there's
// no URL or the image fails to load. The image is decorative (empty alt) — the
// recipe title alongside it is the accessible label.
export const RecipeImage = ({
	src,
	seed,
	tags,
	title,
	icon,
	className,
	loading = 'lazy',
}: Props) => {
	const [broken, setBroken] = useState(false)
	if (!src || broken) {
		return (
			<RecipePlaceholder
				seed={seed}
				tags={tags}
				title={title}
				icon={icon}
			/>
		)
	}
	return (
		<img
			src={src}
			alt=""
			className={className}
			loading={loading}
			onError={() => setBroken(true)}
		/>
	)
}
